import { QRCodeSVG } from 'qrcode.react';
import React from 'react';

const QRCode: React.FC<
  {
    readonly value: string;
    readonly fgColor?: string;
  } & React.SVGProps<SVGSVGElement>
> = ({ value, ...props }) => {
  return <QRCodeSVG value={value} {...props} />;
};

export default QRCode;
